export default "__VITE_ASSET___ltcRa8x__"